module.exports = __webpack_public_path__ + "static/env/$env.bin.js";